import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=e9eaf136&scoped=true&"
import script from "./footer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./footer.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./footer.vue?vue&type=style&index=0&id=e9eaf136&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9eaf136",
  null
  
)

export default component.exports